export default "__VITE_ASSET__Ng$NZfzy__"